import React from "react";
import Testimonials from "../pages/Testimonialsabout";
import Visionn from "../pages/Visionn";

const AboutSection = () => {
  return (
    <>
      {/* Breadcrumb Section */}
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>About Us</h1>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section pt-5">
        {/* <div className="shape">
          <img src="/images/shape/shape-7.png" alt="Shape decoration" />
        </div> */}
        <div className="container">
          <div className="row">
            {/* Left Image */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="about-left-image">
                <img src="/images/about-us.jpeg" alt="Pune Corporate Cars India Private Limited" />
              </div>
            </div>

            {/* Right Content */}
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="section-title  mb_30">
                {/* <span className="sub-title">Pune Corporate Cars India Private Limited</span> */}
                <h2 className="title">
                  Professional, Reliable & Premium <br />
                  Corporate Cab Services in Pune
                </h2>
              </div>

              <p className="mb_30">
                Pune Corporate Cars India Pvt. Ltd., established in 2009, is a trusted provider of chauffeur-driven corporate mobility solutions in India, delivering safe, reliable, and technology-enabled transportation services for businesses across Pune and pan-India. Backed by over 16 years of industry experience, we specialize in Corporate Chauffeured Car Rental (CCR) and Employee Transportation Services (ETS) tailored to the evolving needs of multinational corporations, large enterprises, IT & ITES companies, travel and tourism firms, hotels, and government organizations. Our corporate mobility solutions are designed to support seamless business travel, employee safety, punctual operations, and cost-efficient transportation management. We are an ISO 9001:2015 and ISO 14001:2015 certified organization, reflecting our commitment to quality management systems and environmentally responsible operations. With a strong focus on compliance, service quality, and operational excellence, we help organizations streamline their transportation requirements while maintaining the highest standards of safety and professionalism. At Pune Corporate Cars India Pvt. Ltd., our success is driven by professionally trained chauffeurs, a well-maintained fleet, advanced technology systems, and robust operational processes. Our commitment to service excellence, regulatory compliance, and customer satisfaction has enabled us to build long-term partnerships with reputed corporate clients, positioning us as a preferred corporate car rental and employee transport partner in India.

              </p>

              {/* <div className="about-info-block mb_30">
                <div className="about-info-icon">
                  <i className="icon-35"></i>
                </div>
                <div className="about-info-content">
                  <h5 className="about-info-title">Corporate Employee Transportation</h5>
                  <p className="about-info-text">
                    Whether it’s daily employee pick-up and drop, or company event shuttles, our fleet
                    offers convenient and dependable solutions for businesses of all sizes.
                  </p>
                </div>
              </div> */}

           

              {/* <div className="about-info-block">
                <div className="about-info-icon">
                  <i className="icon-33"></i>
                </div>
                <div className="about-info-content">
                  <h5 className="about-info-title">24/7 Support & Fleet Management</h5>
                  <p className="about-info-text">
                    Our operations team is available round the clock to assist with bookings, route planning,
                    and real-time tracking — making corporate travel simple and stress-free.
                  </p>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </section>

      {/* Future sections can go here */}
      <Visionn/>
      <Testimonials/>
    </>
  );
};

export default AboutSection;
